import './AppointedRequestsRow.css';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import * as Icon from 'react-bootstrap-icons';
import Badge from 'react-bootstrap/Badge';
import Swal from 'sweetalert2';
import ClientDetails from '../ClientDetails/ClientDetails';
import Reschedule from '../Reschedule/Reschedule';

const AppointedRequestsRow = (props) => {
  const dispatch = useDispatch();
  const request = useSelector((store) => store.requestReducer.appointments);
  const [clientDetails, setClientDetails] = useState({});
  const [requestDetails, setRequestDetails] = useState([]);
  const [clientModal, setClientModal] = useState(false);
  const [rescheduleModal, setRescheduleModal] = useState(false);

  const handleShowRescheduleModal = () => {
    setRescheduleModal(true);
    dispatch({ type: 'FETCH_PENDING_REQUESTS' });
  }

  const handleShowClientModal = () => {
    setClientModal(true);
  }

  const deleteRequest = (id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this request',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
        dispatch({ type: 'DELETE_REQUEST', payload: id })
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'Referral NOT deleted'
        )
      }
    })
  }

  const rescheduleTime = async (id) => {
    const foundRequest = await request.filter(r => r.id === id)
    setRequestDetails(foundRequest);
    handleShowRescheduleModal();
  }
  const returnPendingRequest = (id) => {
        Swal.fire({
      title: 'Are you sure?',
      text: 'You will be moving client to pending',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, move it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
        dispatch({ type: 'RETURN_REQUEST', payload: id })
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'Referral NOT moved'
        )
      }
    })
  }
  function timeConverter(timestamp) {
    const time = new Date(timestamp);
    const fd = new Intl.DateTimeFormat('en-us').format(time);
    return fd.toString();
  }

  const displayDetails = (client) => {
    setClientDetails(client);
    handleShowClientModal();
  }

  useEffect(() => {
    dispatch({ type: 'FETCH_REQUESTS' });
  }, []);

  return (
    <tbody>
            <Reschedule
        rescheduleModal={rescheduleModal}
        setRescheduleModal={setRescheduleModal}
        handleShowRescheduleModal={handleShowRescheduleModal}
        request={requestDetails}
      />
            <ClientDetails
        clientModal={clientModal}
        setClientModal={setClientModal}
        client={clientDetails}
      /> 
      {props.searchResults.map(request => (
        <tr key={request.id}>
          <td scope="row" className="text-center px-0 mx-0">{timeConverter(request.appt_date)}</td>
          <td scope="row" className="text-center px-0 mx-0">{request.name}</td>
          <td width="50%" scope="row" className="text-center px-0 mx-0">{request.request_items}</td>
          <td scope="row" className="text-center px-0">
          <Icon.CalendarCheck
              className="mx-1"
              type="button"
              color="orange" size={30}
              onClick={() => {
                rescheduleTime(request.id)
              }}
            />
            <Icon.InfoSquare
              className="mx-1"
              type="button"
              color="royalblue" size={30}
              onClick={() => {
                displayDetails(request)
              }}
            />
            <Icon.Trash
              className="ml-1"
              type="button"
              color="red" size={30}
              onClick={() => deleteRequest(request.id)}
            />
  
          </td>
        </tr>
      ))} 
    </tbody>
  );
}

export default AppointedRequestsRow;